<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header p-2">
                <h6 class="modal-title">{{$t('Bin')}}-{{$t('Catalog Mapper')}}</h6>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeDialog()">
                    <span aria-hidden="true">
                        <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;"></cancel-icon>
                    </span>
                </button>
            </div>
            <div class="modal-body">
              <div class="body-sub-wapper" style="height:100%">
                  <div class="common-input-field w-100" style="margin-top:7px;">
                      <label>{{$t('Bin path')}} <span style="font-size: 15px">*</span></label>
                      <div style="flex: 1;display: flex; flex-direction: column; justify-content: center;width:100%;">
                          <div class="search-bar-comm-style" style="display: inline-flex;">
                              <FolderMultiselect :enableFolderBrowser="true" ref="newPath" @folderSelectionChanged="handlePathSelection" :enableMultiSelect="false" :setDefaultFocus="false" :selectedFolders="getSelectedBinPath" style="width:100%;"></FolderMultiselect>
                          </div>
                      </div>
                  </div>
                  <div class="common-input-field w-100" style="margin-top:7px;">
                      <label>{{$t('Catalog')}} <span style="font-size: 15px">*</span></label>
                      <div style="flex: 1;display: flex; flex-direction: column; justify-content: center;">
                          <div class="search-bar-comm-style" style="display: inline-flex;">
                              <catalog-dropdown 
                                  class="catalog-drowpdown-wrapper"
                                  :selectedOptions="selectedCatalogsArr" 
                                  @updatedCatalogsList="updatedCatalogsListComp"
                                  @removedCatalogFromList="removedCatalogFromListComp"
                                  :allowSingleSelect="false"
                                  :allowSingleSelectFromBrowse="false"
                                  :enableCatBrowser="true" style="width:100%;"></catalog-dropdown>
                          </div>
                      </div>
                  </div>
                  <div class="common-input-field w-100" style="display: block;justify-content: flex-start;margin-top:7px;height:95px;">
                    <div style="display: flex;">
                        <label style="width:40%;padding-top:8px;">{{$t('Create Catalog as Storage')}}</label>
                        <div class="search-bar-comm-style" style="padding-top:8px;">
                            <div class="custom-control custom-switch">
                                <input
                                    v-on:click="updateApplyRecursivley($event.target.checked)"
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="customSwitch001"
                                    :checked='applyRecursively'/>
                                <label class="custom-control-label" for="customSwitch001"></label>
                            </div>
                        </div>
                    </div>
                    <div class="config-desc"> 
                      {{$t('Note')}}: {{$t('On enabling, catalog path will be created similar to storage path and asset will be tagged to created catalog')}}
                    </div>
                  </div>
              </div>    
            </div>
                <div class="modal-footer p-0 primary-btn-style" style="margin-top:0px !important">
                    <div>
                        <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="closeDialog()">{{$t('Cancel')}}</button>
                        <button class="btn btn-outline-primary mr-3" @click="saveChanges()">{{$t('Save')}}</button>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
    
<script>
    import cancelIcon from "../core/InlineCancelField.vue"
    import catalogDropdown from "../categories/CatalogMultiselectDropdown.vue";
    import FolderMultiselect from "../bins/binsFoldersMultiDropdown.vue";
    
    export default {
        props:["selectedMapper"],
        data(){
            return{
                selectedCatalog:null,
                selectedCatalogsArr:[],
                applyRecursively:false,
                browsedFolderPath: null,
                selectedCatParentIdList:[]
            };
        },
        components:{
          'cancel-icon':cancelIcon,
          'catalog-dropdown':catalogDropdown,
          FolderMultiselect
        },
        computed:{
          getSelectedBinPath(){
            if(this.selectedMapper && 'bin_path' in this.selectedMapper && this.selectedMapper.bin_path){
              const lastIndex = this.selectedMapper.bin_path.lastIndexOf('/');
              const parent_id_path = this.selectedMapper.bin_path.substring(0, lastIndex);
              const id = this.selectedMapper.bin_path.substring(lastIndex + 1);

              // Create the dictionary object
               return  {
                id: id,
                _id: id,
                parent_id_path: parent_id_path,
                path: this.selectedMapper.bin_name_path,
                dir_name: this.selectedMapper.bin_name_path.substring(this.selectedMapper.bin_name_path.lastIndexOf('/') + 1)
              };
            }
            return null;
          }
        },
        methods:{
            updateApplyRecursivley(val){
                this.applyRecursively = val;
            },
            removedCatalogFromListComp(option){
                if(this.selectedCatParentIdList.includes(option.parent_id_path + "/" + option._id)){
                    this.selectedCatParentIdList = this.selectedCatParentIdList.filter(op=>op != (option.parent_id_path + "/" + option._id));
                }
            },
            updatedCatalogsListComp(option){
                let catIdPath = option.parent_id_path + "/" + option._id;
                if(this.selectedCatParentIdList){
                    this.selectedCatParentIdList.push(catIdPath)
                }else{
                    this.selectedCatParentIdList = [catIdPath]
                }
            },
            handlePathSelection(folderIdPath){
                let parentIdPath = "";
                if(Array.isArray(folderIdPath)){
                    parentIdPath = folderIdPath[0]
                }else{
                    parentIdPath = folderIdPath;   
                }
                this.browsedFolderPath = parentIdPath.parent_id_path + "/"+ parentIdPath.id;
            },
            closeDialog(){
                this.$emit("closeDialog");
            },
            saveChanges(){
              if(!this.browsedFolderPath || this.browsedFolderPath.length <= 0){
                alert("Please select valid Bin path");
                return;
              }
              if(!this.selectedCatParentIdList || this.selectedCatParentIdList.length <= 0){
                alert("Please select valid Catalog path");
                return;
              }
                let mapperInfo = {
                  bin_path : this.browsedFolderPath,
                  catalog_path: this.selectedCatParentIdList,
                  create_children_folder_as_catalog:  this.applyRecursively
                }
                if(this.selectedMapper){
                    mapperInfo['uid'] = this.selectedMapper.uid;
                    this.$emit("mapperUpdated",false,mapperInfo);
                }else{
                    this.$emit("mapperUpdated",true,mapperInfo);
                }
            }
        },
        created(){
            if(this.selectedMapper){
                if('bin_path' in this.selectedMapper){
                    this.browsedFolderPath = this.selectedMapper.bin_path;
                }
                if('catalog_info' in this.selectedMapper && this.selectedMapper.catalog_info.length > 0){
                    this.selectedCatalogsArr = this.selectedMapper.catalog_info;
                }
                if('catalog_path' in this.selectedMapper && this.selectedMapper.catalog_path.length > 0){
                    this.selectedCatParentIdList = this.selectedMapper.catalog_path;
                }
                if('create_children_folder_as_catalog' in this.selectedMapper){
                    this.applyRecursively = this.selectedMapper.create_children_folder_as_catalog;
                }
            }
        },
    }
    </script>
    
    <style scoped lang="scss">
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;
    
    
    .config-desc{
      color: $dull-text-color;
    }
    .common-input-field{
        margin-inline-start: 0px;
        display: inline-block;
        width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background: $primary-background;
        border: $secondary-border-color !important;
        padding-bottom:22px;
        label{
            width: 30%;
            color: $secondary-text-color;
            word-break: break-word;
        }
        input{
            flex:1;
        }
    }
    .input-text-field{
        height: 44px;
        width: 100% !important;
        padding-inline-start: 2%;
        padding-inline-end:2%;
        overflow: hidden;
    }
    
    /*.modal-dialog {
        max-width: 500px;
        width: 500px;
        height: auto;
        margin: 0;
        padding: 0;
        max-height: 100%;
      }
      
      .modal-content {
        height: 100%;
        // min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
          background: $primary-background;
          height: 90%;
          overflow: auto;
          padding:10px;
        }
      }
    
    .modal {
        text-align: center;
        padding: 0 !important;
        // display: block;
        position: fixed;
        inset-inline-start: 0px;
        top: 0px;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    .modal:before {
        content: "";
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }

    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
        max-height:90%;
        height: auto;
        width:70%;
    }
    */

    .modal-dialog {
        max-width: 500px !important;
        width: 500px !important;
        // height: 60% !important;
        margin: 0;
        padding: 0;
    }
  
    .modal-content {
        height: auto !important;
        max-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            max-height: 450px;
            overflow: auto;
            padding: 1rem !important;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: inline-flex;
        position: fixed;
        align-items: center;
        justify-content: center;
        
    }
    .modal:before {
        content: "";
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }
    
    .btn{
        font-size:14px !important;
        height:100%;
    }
    
    .search-bar{
      background: $primary-background!important;
      height:40px;
      width: 250px !important;
      float: inline-start;
      padding-inline-start: 12px;
      padding-bottom: 2px;
      border:$border-color !important;
    }
    
    .height-set{
      height: calc(100vh - 170px);
      background: $primary-background;
      .group-name{
        text-align: start;
        padding:16px 3%;
        font-size:27px;
        display:flex;
      }
      .group-members{
        height: calc(100% - 90px);
        cursor: pointer;
      }
    }
    
    .add-user-icon-wrapper{
        height: 59px;
        width: 60px;
        line-height: 54px;
        border-radius: 6px;
        background: $primary-background;
        color: $add-button-text-color;
        border: 1px solid $add-button-border-color; 
        display:flex;
        svg{
          margin:auto;
        }
    }
    
    .add-user-icon-wrapper:hover{
        color: $add-button-text-color-hover;
        border: 1px solid $add-button-border-on-hover; 
    }
    
    .editIcon {
        margin-inline-start: 9px;
        margin-top: 0px
    }
    
    .comm-input-field-style{
        background: $primary-background!important;
        height:40px;
        width: 100% !important;
        float: inline-start;
        padding-inline-start: 12px;
        padding-bottom: 2px;
        border: $border-color!important;
    }
    
    .search-bar-comm-style{
      height:60px;
    }
    
    #contact_number_input::-webkit-outer-spin-button,
    #contact_number_input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    
    .close-icon:hover{
      background: #373737;
      border-radius: 20px;
    }
    
      .key-div {
        text-align: end;
        color: $dull-text-color;
      }
      .value-div {
        text-align: start;
        margin-inline-start: 7px;
        width: 100%;
        font-weight: 500;
        input,select{
          padding-inline-start:4px;
        }
      }
    
    .activeTag{
        color: $active-blue !important;
    }
    
    .activeclass {
      color: $active-blue;
    }
    
    table {
      background: transparent;
      thead {
        th {
          color: $dull-text-color;
          border-top: none !important;
          border-bottom: none !important;
        }
      }
      tbody {
        color: $text-color;
        td {
          border-top: none !important;
        }
      }
    }
    
    .btn {
      font-size: $input-field-and-label-font-size !important;
      height: 100%;
    }
    
    .custom-control-label::before {
      background-color: $primary-background;
    }
    
    table.users-basic-info-table .editIcon {
      visibility: hidden;
    }
    table.users-basic-info-table td.value-div:hover .editIcon {
      visibility: visible;
    }
    
    .disablefield {
      border: none !important;
      pointer-events: none;
    }
    
    .force-logout {
      position: relative;
      inset-inline-start: 5px;
      bottom: 4px;
    }
    .force-logout:hover {
      text-decoration: underline;
    }
    .activestatus {
      color: $active-green-color !important;
    }
    .validationmessage {
      color: $danger-color;
      font-size: 11px;
    }
    
    .nav-item{
        color: $dull-text-color !important;
    }
    
    .active{
        background: $primary-background !important;
        color: $text-color !important;
    }
    .top-nav-bar{
        background: $primary-background;
    }
    
    .tags-display-ul .show-tags-delete{
      visibility:hidden;
    }
    
    .tags-display-ul li:hover .show-tags-delete{
      visibility: visible;
    }
    
    .editIcon{
      visibility:hidden;
    }
    
    .group-name:hover .editIcon{
      visibility: visible;
    }
    
    .show-tags-delete{
      position: relative;
      top: 2px;
    }
    
    .breadcrumb{
      padding: .75rem 1rem !important;
      background: $primary-background !important;
        .active-text-nav-bar{
            color: $text-color !important;
            text-decoration: none !important
        }
        .active-text-nav-bar:last-child{
                color: $active-blue !important;
                font-size:17px;
        }
        .breadcrumb-item{
            a{
                color: $text-color;
                font-weight:600;
            }
            a:hover{
                text-decoration: underline;
            }
        }    
    }
    
    .delete-user-icon{
      visibility: hidden;
    }
    
    .comm-tags-class:hover .delete-user-icon{
      visibility: visible;
    }
    
    /* width */
    ::-webkit-scrollbar {
      width: 8px;
    }
    
    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }
    
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }
    .border{
        border: $border-color !important;
    }
    
    .activePool{
        color: $active-blue;
    }
    
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        .modal-title{
          color:$text-color;
        }
    }
    
    .modal-header .close {
        margin: 0px !important;
        padding: 0px !important;
    }
    
    ul{
        list-style-type: none;
    }
    
    .primary-btn-style {
      margin-top: 1%;
      height:55px;
      button {
        height: 35px;
        width: 70px;
        border-radius: 5px;
        font-size:14px;
      }
    }
    
    .search-bar-comm-style{
      height:30px;
      position:relative;
      input{
        border:$border-color;
        height: 25px;
        padding-inline-start: 6%;
      }
      svg{
        position: absolute;
        inset-inline-start: 21px;
        top: 58%;
      }
    }
    
    .secondary-btn-style{
      color:$text-color;
    }
    
    .modal-footer{
        justify-content: flex-end;
    }
    
    .view-tags {
      font-size:12px!important;
      height: 30px!important;
      display: inline-flex!important;
      margin: 2px!important;
      border: 1px solid $tags-border-color!important;
      border-radius: 15px!important;
      min-width: 50px!important;
      padding: 0!important;
      text-align: center;
      width: auto!important;
      padding-inline-start: 1px!important;
      justify-content: center;
      padding-top: 4px!important;
      background: $tags-background-color;
      span {
        padding: 0px 8px !important;
        margin-inline-start: 0px !important;
        font-size:12px !important;
        border-radius: 15px !important;
        position: relative !important;
        top: 1px !important;
      }
    }
    
    .activeTag{
        color: $active-blue !important;
    }
    
    .secondary-btn-style:hover{
      text-decoration: underline;
    }
    
    .close-icon:hover{
      background: $icon-hover;
      border-radius: 20px;
    }
    
    .search-bar-comm-style{
       text-align: center;
       height:auto;
      .search-bar{
        background: $primary-background!important;
        height:42px;
        //width: 180px !important;
        //float: inline-start;
        width:94% !important;
        padding: 0px 12px 0 8px;
        padding-inline-start: 12px;
        border:$border-color !important;
      }
    }

    ::v-deep{
      .catalog-drowpdown-wrapper{
        .multiselect{
          height: auto !important;
        }
      }
    }
    
    </style>